import { Component, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RelatedBlogComponent } from './related-blog/related-blog.component';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent {
    public Editor = ClassicEditor;
    window:any=<any>window;
    $:any=<any>this.window.$;
    notification:any = {
      danger: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'danger'}}),
      success: (obj:any) => this.window.flowup.signal.emit({name: 'notification', detail: {text: obj.text, type: 'success'}})
    };
    openModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`).children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'block');
    };
    closeModal = (selector:any) => {
        let modal_wrapper = Array.from(this.window.document.querySelector(`${selector}`)?.children || []);
        modal_wrapper.forEach((el:any) => el.style.display = 'none');
    };
    filter:any = {
      text: ''
    };
    updateView:any = () => {
        setTimeout(() => {
            if(!this.queryparams()['type'] || !this.window.usher.isLogged()) {
                this.closeModal('#blogModal');
                this.closeModal('#deleteBlogModal');
                this.initModel();
            } 
            if(this.queryparams()['type'] == 'delete' && !!this.queryparams()['blog-selected'] && !!this.window.usher.isLogged()) {
                this.closeModal('#blogModal');
                this.openModal('#deleteBlogModal');
            }
            if(this.queryparams()['type'] == 'create' && !this.queryparams()['blog-selected'] && !!this.window.usher.isLogged()) {
                this.closeModal('#deleteBlogModal');
                this.openModal('#blogModal');
            }
            if(this.queryparams()['type'] == 'update' && !!this.queryparams()['blog-selected'] && !!this.window.usher.isLogged()) {
                this.closeModal('#deleteBlogModal');
                this.openModal('#blogModal');
            }
            this.cd.detectChanges();
        }, 50);
    };
    queryparams:any = () => this.route.snapshot.queryParams;
    params:any = () => this.route.snapshot.params;
    changeQueryParam:any = (values:any = {}) => new Object({ ...this.route.snapshot.queryParams, ...values });
    rand = (num:any = null) => {
        num = num || 12;
        var text = "";
        var characters = "_ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < num; i++) {
            text += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return text;
    };

    blog_model:any = {
        name: this.window.appInfo.public_token_parent,
        configuration: {
            type: "blog",
            owner: this.window.appInfo.public_token_parent,
            id: this.rand(),
            cover: "",
            title: "",
            subtitle: "",
            tags: [],
            paragrafi: [],
            related_objects: []
        }
    };
    paragrafo_model:any = {
        title: "",
        description: ""
    };
    tag:any = "";
    constructor(
        private cd: ChangeDetectorRef,
        private route:ActivatedRoute,
        private router:Router,
        private zone: NgZone
    ) {
        route.queryParams.subscribe((p:any) => this.updateView());
    }

    initModel = () => {
        this.blog_model = {
            name: "",
            configuration: {
                type: "blog",
                owner: this.window.appInfo.public_token_parent,
                id: this.rand(),
                title: "",
                subtitle: "",
                tags: [],
                paragrafi: [],
                related_objects: []
            }
        };
        this.initParagrafo();
    };

    initParagrafo = () => {
        this.paragrafo_model = {
            title: "",
            description: ""
        };
    };

    ngAfterViewInit() {
        this.window.scrollTo(0,0);
        this.window.document.addEventListener("usher", this.updateView.bind(this));
        this.window.bigBucket.element.addEventListener('connect', this.updateView.bind(this));
    };

    ngOnDestroy() {
        this.window.document.removeEventListener("usher", this.updateView.bind(this));
        this.window.bigBucket.element.removeEventListener('connect', this.updateView.bind(this));
    };

    get = (pt:any = undefined) => this.window.bigBucket.getBuckets()[this.window.appInfo.buckets.bigBucket?.container]?.objects?.filter(e => e.configuration.type == "blog" && 
        (!pt || e.public_token == pt) &&
        (!this.filter.text || e.configuration.title?.toLowerCase().includes(this.filter.text?.toLowerCase()))) || [];

    getBlog = () => {
        if(this.queryparams()['blog-selected']) return this.get(this.queryparams()['blog-selected'])[0] || this.blog_model;
        return this.blog_model;
    };
    
    handleModal = (blog:any = undefined, type:any = undefined) => {
        this.router.navigate([`/blog`], { queryParams: this.changeQueryParam({ "blog-selected" : blog, "type" : type }) });
    };

    getCover = async (input:any) => {
        this.window.flowup.signal.emit({name: 'get-files', detail: {
            event: input,
            callback: async (parsed_files) => {
                try {
                    this.window.flowup.signal.emit({name: 'upload-files', detail: {
                        collection: parsed_files,
                        callback: async (sent) => {
                            this.getBlog().configuration.cover = new Object({
                                ...sent[0]
                            });
                            //if(this.getCurrentObject().public_token) await this.getCurrentObject().update();
                            this.updateView();
                            return this.notification.success({text: "Cover caricata con successo."});
                        },
                        error: (file) => {
                            return this.notification.danger({text: `Errore nel caricamento del file ${file.filename}`});
                        }
                    }});
                } catch(e) {
                    console.log(e);
                    return this.notification.danger({text: 'Errore. Riprova più tardi.'});
                }
            }
        }});
    };

    check = () => {
        if(!this.getBlog().configuration.title) {
            this.notification.danger({ text: 'Inserisci il titolo!' });
            return false;
        }
        if(!this.getBlog().configuration.cover) {
            this.notification.danger({ text: 'Inserisci una cover!' });
            return false;
        }
        if(!this.getBlog().configuration.paragrafi?.length) {
            this.notification.danger({ text: 'Inserisci almeno un paragrafo!' });
            return false;
        }
        return true;
    };

    handleBlog = async () => {
        if(!this.check()) return;
        try {
            if(!!this.queryparams()['blog-selected'] && this.getBlog().public_token) await this.getBlog().update();
            else await this.window.bigBucket.getBuckets()[this.window.appInfo.buckets.bigBucket?.container].addObject(this.getBlog());
            this.initModel();
            this.handleModal(undefined, undefined);
            this.notification.success({text: 'Articolo del blog creato con successo'});
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: "Errore. Riprova più tardi."});
        };
    };

    deleteBlog = async () => {
        try {
            await this.getBlog()?.delete();
            this.notification.success({text: 'Articolo del blog cancellato con successo'});
            this.router.navigate([`/blog`], { queryParams: this.changeQueryParam({ "blog-selected" : undefined }) });
            this.handleModal(undefined, undefined);
            return;
        } catch(e) {
            console.log(e);
            return this.notification.danger({text: "Errore. Riprova più tardi."});
        }
    };

    addTag = () => {
        if(!this.tag) return;
        this.getBlog().configuration.tags = this.getBlog().configuration.tags || [];
        if(!!this.getBlog().configuration.tags?.includes(this.tag.toLowerCase())) return this.notification.danger({ text: 'Tag già presente!' });
        this.getBlog().configuration.tags.push(this.tag.toLowerCase());
    };

    /* GESTIONE PARAGRAFI */

    openParagrafoModal = (paragrafo:any = undefined) => {
        this.closeModal("#blogModal");
        this.closeModal("#deleteBlogModal");
        if(!!paragrafo) this.paragrafo_model = paragrafo;
        this.openModal("#paragrafoModal");
    };

    closeParagrafoModal = () => {
        this.closeModal("#paragrafoModal");
        this.initParagrafo();
        this.updateView();
    };

    openParagrafoDeleteModal = (paragrafo:any = undefined) => {
        this.closeModal("#blogModal");
        this.closeModal("#deleteBlogModal");
        this.closeModal("#paragrafoModal");
        if(!!paragrafo) this.paragrafo_model = paragrafo;
        this.openModal("#deleteParagrafoModal");
    };

    closeParagrafoDeleteModal = () => {
        this.closeModal("#deleteParagrafoModal");
        this.openModal("#paragrafoModal");
    };

    checkParagrafo = () => {
        if(!this.paragrafo_model.title) {
            this.notification.danger({ text: 'Inserisci un titolo!' });
            return false;
        }
        if(!this.paragrafo_model.description) {
            this.notification.danger({ text: 'Inserisci una descrizione!' });
            return false;
        }
        return true;
    };

    handleParagrafo = () => {
        if(!this.checkParagrafo()) return;
        if(!this.paragrafo_model.id) this.getBlog().configuration.paragrafi.push({...this.paragrafo_model, id: this.rand()});
        this.closeParagrafoModal();
    };

    deleteParagrafo = () => {
        let paragrafo_index = this.getBlog().configuration.paragrafi.findIndex(e => e.id == this.paragrafo_model.id);
        if(isNaN(paragrafo_index)) return;
        this.getBlog().configuration.paragrafi.splice(paragrafo_index, 1);
        this.closeModal("#deleteParagrafoModal");
        this.initParagrafo();
        this.updateView();
    };

    /**********************/
}